
import {axiosInstance} from "../axios";
import {deals_apis} from "../ApiConst";
export const Top_Deals = async (payload) => {
//   return await axios.get(`${base_url}api/v0/offer/top-picks/`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: Token,
//     },
//     params: payload,
//   });
    return await axiosInstance.get(deals_apis.top_deals, { params: payload });
};


export const Top_Deals_Suggestions = async (payload) => {
//   return await axios.get(`${base_url}api/v0/offer/top-picks/`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: Token,
//     },
//     params: payload,
//   });
    return await axiosInstance.get(deals_apis.top_deals_suggestions, { params: payload });
};